import { configureStore } from "@reduxjs/toolkit";
import userDetailsReducer from "./slice/userDetailsSlice";
import authReducer from "./slice/authSlice";
export default configureStore({
  reducer: { userDetails: userDetailsReducer, auth: authReducer },
});
